// ==================== SECURE LOGGER ====================
// Savidna CRM - Logger seguro que silencia output en producción
// En producción: SILENCIO TOTAL en consola del navegador
// En desarrollo: logs normales para debugging

const IS_DEV = typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.DEV === true;

// Palabras clave de PII que NUNCA deben aparecer en logs
// (esta lista es una red de seguridad extra; idealmente el caller no pasa PII)
const PII_PATTERNS = [/@[a-z0-9.-]+\.[a-z]{2,}/i // emails
];
function maskPII(args: unknown[]): unknown[] {
  if (IS_DEV) return args;
  return args.map(arg => {
    if (typeof arg === 'string') {
      let masked = arg;
      PII_PATTERNS.forEach(p => {
        masked = masked.replace(p, '[REDACTED]');
      });
      return masked;
    }
    return arg;
  });
}
export const logger = {
  log: (...args: unknown[]) => {
    if (IS_DEV) console.log(...maskPII(args));
  },
  warn: (...args: unknown[]) => {
    if (IS_DEV) console.warn(...maskPII(args));
  },
  error: (...args: unknown[]) => {
    if (IS_DEV) console.error(...maskPII(args));
  },
  security: (event: string) => {
    if (IS_DEV) {
      console.log(`[SECURITY] ${event}`);
    }
  }
};